import { Navigate } from 'react-router';
import { OrganizationPipeline } from '~/apps/consumer/components/BuyerOfferAnalysis/OrganizationPipeline/OrganizationPipeline';
import { OrganizationPipelineComingSoon } from '~/apps/consumer/components/ProductFeatures/OrganizationPipelineComingSoon';
import {
  FeatureKey,
  useIsFeatureEnabledForPayload,
} from '~/apps/consumer/hooks/useIsFeatureEnabledForPayload';
import { CenterSpinner } from '~/common/components/CenterSpinner';
import { useAppContext } from '~/services/main/contexts/AppContext';

export const OrganizationPipelinePage = () => {
  const {
    selectedOrganization,
    loadingOrganizations,
    loadingIsSelectedOrgAdmin,
  } = useAppContext();
  const isOrgPipelineEnabledForOrg = useIsFeatureEnabledForPayload({
    featureFlagKey: FeatureKey.ORG_PIPELINE,
    organizationId: selectedOrganization?.id,
  });

  // Uses the offer-coach feature flag
  const isOfferScorecardEnabled = useIsFeatureEnabledForPayload({
    featureFlagKey: FeatureKey.OFFER_COACH,
    organizationId: selectedOrganization?.id,
  });

  if (loadingOrganizations || loadingIsSelectedOrgAdmin) {
    return <CenterSpinner />;
  }

  if (isOfferScorecardEnabled === false) {
    return <Navigate replace to="/" />;
  }

  if (isOrgPipelineEnabledForOrg === false) {
    return <OrganizationPipelineComingSoon />;
  }

  return <OrganizationPipeline />;
};
